import * as React from 'react'
function SvgShare(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12 10a2 2 0 110 4H8v16h20v-4a2 2 0 114 0v6a2 2 0 01-2 2H6a2 2 0 01-2-2V12a2 2 0 012-2h6zm16.293-4.293a1 1 0 011.414 0l5.586 5.586a1 1 0 010 1.414l-5.586 5.586A1 1 0 0128 17.586V14c-4.412 0-8 3.588-8 8h-4c0-6.618 5.382-12 12-12V6.414a1 1 0 01.293-.707z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgShare
